import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleQuestion,
  faExclamationTriangle,
  faLock,
  faSpinnerThird,
} from '@fortawesome/pro-regular-svg-icons';
import SuperTokens, { SuperTokensWrapper } from 'supertokens-auth-react';
import { signOut } from 'supertokens-auth-react/recipe/passwordless';

import RedirectToRoot from './components/RedirectToRoot';
import { SuperTokensConfig } from './config';
import { captureSignOut, initPostHog } from './lib/utils/posthog';
import Login from './Login';
import Token from './Token';

library.add(faLock, faSpinnerThird, faCircleQuestion, faExclamationTriangle);

SuperTokens.init(SuperTokensConfig);

// Simple view to logout current user session, this could be
// expanded and reworked to either redirect to a CK website
// or show a better designed page.
function SignOut() {
  useEffect(() => {
    const handleSignOut = async () => {
      try {
        await signOut();
        captureSignOut();
      } catch (err) {
        console.error('Error signing out:', err);
      }
    };
    handleSignOut();
  }, []);

  return <div>You're now signed out</div>;
}

function App() {
  useEffect(() => {
    initPostHog();
  }, []);

  return (
    <SuperTokensWrapper>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/token/:type/:contact" element={<Token />} />
          <Route path="/signout" element={<SignOut />} />
          <Route path="*" element={<RedirectToRoot />} />
        </Routes>
      </Router>
    </SuperTokensWrapper>
  );
}

export default App;
